import { useSelector } from "react-redux";
import { selectMicroFrontendId } from "root/libs/ui-containers/src/lib/MicroFrontend/selectors";

import { selectSelectedSegment } from "../../../../../containers/SpotShipmentPage/selectors";

/**
 * Decides whether the input should be hidden or not.
 * We're hiding the input for "Ship Now" private shipments.
 */
export const useShouldHideInput = () => {
  const selectedSegment = useSelector(selectSelectedSegment);
  const microFrontendId = useSelector(selectMicroFrontendId);

  return microFrontendId === "ShipNow" && selectedSegment === "private";
};
